<template>
	<vue-timepicker
		:disabled="disabled"
		required
		v-model="modelTime"
		manual-input
		input-width="6em"
		class="mb-1"
	></vue-timepicker>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
export default {
	components:{
		VueTimepicker
	},
	props: {
		disabled: Boolean,
		value: String
	},
	computed: {
		date(){
			let aux = moment(this.value);
			return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
		},
		modelTime: {
			get() {
				let aux = moment(this.value);
				return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
			},
			set(v) {
				this.$emit("input", `${this.date} ${v}`);
			}
		}
	}
};
</script>
